import { getRootDomain } from "@utilities/base-url";

const enum CookieType {
  LANG = "lang",
  TOKEN = "lpbt",
  ACCOUNT_NUMBER = "lpbt_acc",
  HASHED_PASSWORD = "lpbt_hs",
  CURRENCY = "currency",
  AFFILIATE = "affiliate",
  LAST_PROMO_ID = "lpbt_last_promo",

  PRICE_TOTAL = "lpbt_total",
  REDIRECT_URL = "lpbt_redirect",

  IS_BETA = "is_beta",

  // best-esim-for-* page to credit with a purchase; survives logout.
  LANDING_PAGE = "bnesim_landing_page",
}

export const CookieOptions: Cookies.CookieAttributes = {
  domain: getRootDomain(),
  httpOnly: false,
  secure: true,
  sameSite: "strict",
};

export default CookieType;
